import { useState, useCallback, useEffect } from 'react'
import taskService from '../services/tasks/taskService'
import { showSuccessToast } from '../helpers/toast'

export default function useComments(membertaskId) {
  const [comments, setComments] = useState([])
  const [loading, setLoading] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  const fetchComments = useCallback(async () => {
    if (!membertaskId) return
    setLoading(true)
    try {
      const response = await taskService.getComments(membertaskId)
      setComments(response.data.results || response.data)
    } catch {
      setComments([])
    } finally {
      setLoading(false)
    }
  }, [membertaskId])

  useEffect(() => {
    fetchComments()
  }, [fetchComments])

  const addComment = useCallback(async (comment, files = []) => {
    setSubmitting(true)
    try {
      await taskService.addComment(membertaskId, comment, files)
      showSuccessToast('Komenti u shtua.')
      await fetchComments()
    } finally {
      setSubmitting(false)
    }
  }, [membertaskId, fetchComments])

  const deleteComment = useCallback(async (id) => {
    try {
      await taskService.deleteComment(id)
      showSuccessToast('Komenti u fshi.')
      await fetchComments()
    } catch {
      // error handled by interceptor
    }
  }, [fetchComments])

  return {
    comments,
    loading,
    submitting,
    addComment,
    deleteComment,
    refresh: fetchComments,
  }
}
